import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserProfileAvatar } from 'types/userProfile';
import { profileService } from 'domain/profile/api/profileService';

function useGetProfileAvatar(): UseQueryResult<UserProfileAvatar | null> {
  return useQuery({
    queryKey: ['profileAvatar'],
    queryFn: profileService.getProfileAvatar,
  });
}

export default useGetProfileAvatar;
